import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import SlideOutForm from './components/SlideOutForm';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import CustomSolution from './pages/CustomSolution';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Disclaimer from './pages/Disclaimer';
import Features from './pages/Features';
import AIIntelligence from './pages/AIIntelligence';
import DataManagement from './pages/DataManagement';
import ReportingAnalytics from './pages/ReportingAnalytics';
import WorkflowAutomation from './pages/WorkflowAutomation';
import CustomDevelopment from './pages/CustomDevelopment';
import SecurityCollaboration from './pages/SecurityCollaboration';
import TechnicalArchitecture from './pages/TechnicalArchitecture';
import Documentation from './pages/Documentation';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-gray-50">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:productName" element={<ProductDetail />} />
            <Route path="/solutions/:solutionName" element={<CustomSolution />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/features/ai-intelligence" element={<AIIntelligence />} />
            <Route path="/features/data-management" element={<DataManagement />} />
            <Route path="/features/reporting-analytics" element={<ReportingAnalytics />} />
            <Route path="/features/workflow-automation" element={<WorkflowAutomation />} />
            <Route path="/features/custom-development" element={<CustomDevelopment />} />
            <Route path="/features/security-collaboration" element={<SecurityCollaboration />} />
            <Route path="/technical-architecture" element={<TechnicalArchitecture />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
          </Routes>
        </main>
        <Footer />
        <SlideOutForm />
      </div>
    </Router>
  );
}

export default App; 